import { Col } from "antd";
import { Fade } from "react-awesome-reveal";
import { withTranslation } from "react-i18next";
import { ContentBlockProps } from "./types";
import { StyledRow, CoreTitle, MinKeywords, MinPara } from "./styles";

const MiddleBlueBlock = ({
    text1,
    text2,
    text3,
    direction,
    id,
    t,
}: ContentBlockProps) => {
    return (
        <StyledRow
            justify="center"
            align="middle"
            id={id}
            direction={direction}
            style={{
                backgroundColor: '#2159A6',
                minHeight: '250px',
                padding: '20px 0',
            }}
        >
            <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'center' }}>
                <Fade direction={direction} triggerOnce>
                    <div>
                        <CoreTitle>{t(text1)}</CoreTitle>
                        <MinPara>{t(text2)}</MinPara>
                        <MinKeywords>{t(text3)}</MinKeywords>
                    </div>
                </Fade>
            </Col>
        </StyledRow>
    );
};

export default withTranslation()(MiddleBlueBlock);
